import { Colors } from '~/assets/style/colors'
import { IconProps } from '~/components/Icon'

// Shared chip appearance for the ADM & PBS stack changelogs.
export const CHANGELOG_ICONS: Record<string, IconProps> = {
  added: { name: 'add_circle', fill: Colors.Isle, stroke: Colors.Isle },
  changed: { name: 'edit', fill: Colors.Fall, stroke: Colors.Fall },
  removed: { name: 'close', fill: Colors.Blood, stroke: Colors.Blood },
}

// Per-action chip appearance: icon/border color + background.
export const CHIP_STYLE_BY_ACTION: Record<string, Record<string, string>> = {
  added: { backgroundColor: Colors.Mint, border: `1px solid ${Colors.Isle}`, color: Colors.Ink },
  changed: { backgroundColor: Colors.Ivory, border: `1px solid ${Colors.Fall}`, color: Colors.Ink },
  removed: { backgroundColor: Colors.Mew, border: `1px solid ${Colors.Blood}`, color: Colors.Ink },
}
